module.exports = __webpack_public_path__ + "static/3-2ed472f2ef23d23c18e64e0ebfc4a54c.jpg";